import React from 'react'
import cn from 'classnames'
import KeyboardNavigator from 'components/KeyboardNavigator'
import { decorateFilterInMenu } from 'components/ConversationList/Header/Search/util'
import { propFunc } from 'util/functions'
import oldStyles from './styles.css'
import { styles } from './styles'

const RecentSearches = ({ className, list = [], onSubmit }) => {
  return (
    <div className={className}>
      <div className={cn(oldStyles.SearchSuggestions_title, 'grui mb-4')}>
        Recent searches
      </div>
      <div className="grui mx-3" css={styles.innerList}>
        {list.map(query => (
          <KeyboardNavigator.Item
            key={query}
            css={styles.recentSearch}
            className="grui px-5 py-4 truncate"
            onSelect={propFunc(onSubmit, query, {
              shouldIncludePreviousSubmittedFilters: false,
            })}
            // Prevent setting default active
            active={false}
          >
            <span
              /* eslint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{ __html: decorateFilterInMenu(query) }}
            />
          </KeyboardNavigator.Item>
        ))}
      </div>
    </div>
  )
}

export default RecentSearches
